'use client';

import dynamic from 'next/dynamic';
import type { PropsWithChildren } from 'react';
import { Spinner } from './Spinner/Spinner';

const NoSsr = ({ children }: PropsWithChildren) => {
	// TODO: Should we wrap with suspense so that things like query parameters are ready?
	return <>{children}</>;
};

export default dynamic(async () => Promise.resolve(NoSsr), {
	ssr: false,
	loading: () => <Spinner />,
});
